export default {
  async affiliates(config = {}) {
    return await this.$get({
      url: `${this.$baseurl}/admin/affiliates/statistics`,
      headers: this.headers,
      ...config,
    });
  },
};
